<div style="width: 100%; height: 100%">
  <app-orders-grid
    #grid
    (filterChange)="onFilterChange($event)"
  ></app-orders-grid>
  <!--
  <tablan-grid [options]="gridOptions" [rowData]="rows"></tablan-grid>
  -->
</div>
